

import { baseURL } from '@/axios/fetch';
import useConfigHooks from '@/hooks/config.hooks';
import { CardDataImpl } from '@/interface/config.interface';
import { getUuid, Uuid } from '@/lib';
import { useLateralRoll } from '@/lib/lateralRoll';
import SvgIcon from '@/components/SvgIcon.vue';
import { LockOutlined, VerticalAlignBottomOutlined } from '@ant-design/icons-vue';
import { Popover, Tooltip } from 'ant-design-vue';
import cardListVue from '@/components/student/cardList.vue';
import {
  defineComponent, ref, onMounted,
} from 'vue';

export default defineComponent({
  components: {
    SvgIcon,
    LockOutlined,
    VerticalAlignBottomOutlined,
    aPopover: Popover,
    aTooltip: Tooltip,
    cardListVue,
  },
  setup() {
    const configHooks = useConfigHooks();
    const dataList = ref<Uuid<CardDataImpl>[]>([]);
    const init = async () => {
      dataList.value = getUuid(await configHooks.getStuResourceData());
      console.log(dataList.value, 'value');
    };

    const handleClick = (item: CardDataImpl) => {
      if (item.resourceData?.packageName) {
        const { packageName } = item.resourceData;
        window.open(`${baseURL}/static/installer/${packageName}`, '_blank');
      }
    };

    onMounted(async () => {
      await init();
      useLateralRoll(document.getElementById('cardListVue')!);
    });
    return {
      handleClick,
      dataList,
    };
  },
});
